<template>
  <div class="tree-right" id="treeRight">
    <div class="childs">
      <div class="child" v-for="(dataItem,index) in list" :key="dataItem.s_id +'-child-'+index">
        <div class="child-item" :style="{marginRight: dataItem.children && dataItem.children.length > 1 ? '20px' :''}">
          <div class="childname" :id="dataItem.s_id">
            <div class="content-box" @click="getChildrenNode(dataItem,dataItem.s_id)" :ref="dataItem.s_id" :id="dataItem.s_id">
              <!-- <p v-for="(showItem,index3) in showfields" :key="'showItem'+index3"><strong>{{showItem.name}}</strong><span :style="{'color':showItem.color}">{{dataItem[showItem.key]}}</span></p> -->
              {{ dataItem.s_en_name }}
            </div>
            <div style="width:30px"></div>
            <div class="position-top" v-if="isFirst(dataItem.s_id) && domready" :style="position_top(dataItem.s_id,'top')"></div>
            <div class="position-top" v-if="isLast(dataItem.s_id)" :style="position_top(dataItem.s_id,'bottom')"></div>
          </div>
          <div style="width:160px"></div>
        </div>
        <!-- 递归组件展示子节点 -->
        <div class="child-children" v-if="dataItem.children && dataItem.children.length">
          <RightTree :list="dataItem.children" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTreeList } from "@/api/index";
import LeaderLine from "leader-line-vue";
export default {
  name: "RightTree",
  components: {},
  data() {
    return {
      domready: false,
      lines: [],
      nodeList: [],
    };
  },
  create() {},
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    // showfields: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.domready = true;
      this.$set(this, "nodeList", this.list);
      this.drawArrowLine();
    });
  },
  computed: {
    /**
     * 是否展示树计算属性
     */
  },
  beforeDestroy() {
    /**
     * 离开页面时销毁所有line
     */
    if (this.lines && this.lines.length) {
      this.lines.forEach((line) => {
        line.remove();
      });
    }
  },
  methods: {
    /**
     * 查看追踪详情
     */
    initTreeNodeList(list) {
      list.forEach((el) => {
        if (el && !el.children) {
          el.children = [];
        }
      });
    },
    traceDetail(data) {
      this.$router.push({
        path: "/logTraceDetail",
        query: {
          id: data.id,
          traceId: data.traceId,
        },
      });
    },
    getChildrenNode(item, id) {
      if (item.children) return;
      this.domready = false;
      getTreeList(id).then((res) => {
        let data = res.data?.data || [];
        if (!item.children) {
          this.$set(item, "children", []);
        }
        item.children.push(...data);
        this.$nextTick(() => {
          this.domready = true;
          setTimeout(() => {
              this.drawArrowLine();
          },500)
        });
      });
    },
    /**
     * 递归绘制箭头
     */

    drawArrowLine() {
      this.drawLeaderLine(this.nodeList);
      document.getElementById("treeList").addEventListener("scroll", () => {
        if (this.lines && this.lines.length) {
          this.lines.forEach((line) => {
            line.position();
          });
        }
      });
    },
    /**
     * 销毁所有线条
     */
    destoryLine() {
      if (this.lines && this.lines.length) {
        this.lines.forEach((line) => {
          line.remove();
        });
      }
    },
    /**
     * 根据上下级关系绘制线条
     */
    drawLeaderLine(list) {
      list.forEach((element) => {
        let start = document.getElementById(element.s_id);
        if (element.children && element.children.length) {
          element.children.forEach((child) => {
            let line = LeaderLine.setLine(
              start,
              document.getElementById(child.s_id)
            );
            line.color = "#DADADA";
            line.path = "grid";
            line.size = 1;
            line.setOptions({
              solid: { animation: true },
            });
            this.lines.push(line);
          });
          this.drawLeaderLine(element.children);
        }
      });
    },
    position_top(id, position) {
      let dom = document.getElementById(id);
      let height;
      if (dom) {
        height = dom.clientHeight;
      }
      let rt;
      if (position === "top") {
        rt = {
          height: height / 2 - 2 + "px",
          top: 0,
        };
      }
      if (position === "bottom") {
        rt = {
          height: height / 2 + 1 + "px",
          bottom: 0,
        };
      }
      return rt;
    },
    isFirst(id) {
      return (
        this.nodeList.length > 1 &&
        this.nodeList.map((x) => x.id).indexOf(id) === 0
      );
    },
    isLast(id) {
      return (
        this.nodeList.length > 1 &&
        this.nodeList.map((x) => x.id).indexOf(id) === this.nodeList.length - 1
      );
    },
  },
};
</script>

<style lang="css" scoped>
#treeRight {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
}
.tree-right {
  display: flex;
}
.tree-right p {
  margin: 0;
  font-size: 13px;
}
.tree-right .father {
  width: 70px;
  background-color: red;
  padding: 100px 10px;
}
.tree-right .childs .child {
  display: flex;
  background-color: #fff;
}
.tree-right .childs .child .child-item {
  display: flex;
  align-items: center;
}
.tree-right .childs .child .child-item .childname {
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  width: 350px;
  text-align: center;
  justify-content: center;
  position: relative;
  padding: 10px 0;
}
.tree-right .childs .child .child-item .childname .content-box {
  text-align: left;
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 6px;
  width: 100%;
  -webkit-box-shadow: 0 1px 5px 1px #dadce0;
  box-shadow: 0 1px 5px 1px #dadce0;
  font-family: "Segoe UI", "Roboto", arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
}
.tree-right .childs .child .child-item .childname .position-arrow {
  position: absolute;
  left: -22px;
}
.tree-right .childs .child .child-item .childname .position-top {
  position: absolute;
  width: 3px;
  background-color: #fff;
  left: -23px;
  height: 10px;
}
.tree-right .childs .child .child-item .childarrow {
  height: 100%;
  display: flex;
  align-items: center;
}
.tree-right .childs .child-children {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
